/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CurateRouteImport } from './routes/curate'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as JourneyRouteImport } from './routes/journey'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SpacesRouteImport } from './routes/spaces'
import { Route as StartRouteImport } from './routes/start'
import { Route as GalleryChecksRouteImport } from './routes/gallery_.checks'
import { Route as LearnLessonRouteImport } from './routes/learn.$lesson'
import { Route as WatchSourceItemRouteImport } from './routes/watch.$source.$item'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CurateRoute = CurateRouteImport.update({
  id: '/curate',
  path: '/curate',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/gallery.lazy').then((d) => d.Route))
const JourneyRoute = JourneyRouteImport.update({
  id: '/journey',
  path: '/journey',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SpacesRoute = SpacesRouteImport.update({
  id: '/spaces',
  path: '/spaces',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryChecksRoute = GalleryChecksRouteImport.update({
  id: '/gallery_/checks',
  path: '/gallery/checks',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/gallery_.checks.lazy').then((d) => d.Route),
)
const LearnLessonRoute = LearnLessonRouteImport.update({
  id: '/learn/$lesson',
  path: '/learn/$lesson',
  getParentRoute: () => rootRouteImport,
} as any)
const WatchSourceItemRoute = WatchSourceItemRouteImport.update({
  id: '/watch/$source/$item',
  path: '/watch/$source/$item',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/curate': typeof CurateRoute
  '/gallery': typeof GalleryRoute
  '/journey': typeof JourneyRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRoute
  '/sign-in': typeof SignInRoute
  '/spaces': typeof SpacesRoute
  '/start': typeof StartRoute
  '/gallery/checks': typeof GalleryChecksRoute
  '/learn/$lesson': typeof LearnLessonRoute
  '/watch/$source/$item': typeof WatchSourceItemRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/curate': typeof CurateRoute
  '/gallery': typeof GalleryRoute
  '/journey': typeof JourneyRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRoute
  '/sign-in': typeof SignInRoute
  '/spaces': typeof SpacesRoute
  '/start': typeof StartRoute
  '/gallery/checks': typeof GalleryChecksRoute
  '/learn/$lesson': typeof LearnLessonRoute
  '/watch/$source/$item': typeof WatchSourceItemRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/curate': typeof CurateRoute
  '/gallery': typeof GalleryRoute
  '/journey': typeof JourneyRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRoute
  '/sign-in': typeof SignInRoute
  '/spaces': typeof SpacesRoute
  '/start': typeof StartRoute
  '/gallery_/checks': typeof GalleryChecksRoute
  '/learn/$lesson': typeof LearnLessonRoute
  '/watch/$source/$item': typeof WatchSourceItemRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/curate'
    | '/gallery'
    | '/journey'
    | '/review'
    | '/settings'
    | '/sign-in'
    | '/spaces'
    | '/start'
    | '/gallery/checks'
    | '/learn/$lesson'
    | '/watch/$source/$item'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/curate'
    | '/gallery'
    | '/journey'
    | '/review'
    | '/settings'
    | '/sign-in'
    | '/spaces'
    | '/start'
    | '/gallery/checks'
    | '/learn/$lesson'
    | '/watch/$source/$item'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/curate'
    | '/gallery'
    | '/journey'
    | '/review'
    | '/settings'
    | '/sign-in'
    | '/spaces'
    | '/start'
    | '/gallery_/checks'
    | '/learn/$lesson'
    | '/watch/$source/$item'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  CurateRoute: typeof CurateRoute
  GalleryRoute: typeof GalleryRoute
  JourneyRoute: typeof JourneyRoute
  ReviewRoute: typeof ReviewRoute
  SettingsRoute: typeof SettingsRoute
  SignInRoute: typeof SignInRoute
  SpacesRoute: typeof SpacesRoute
  StartRoute: typeof StartRoute
  GalleryChecksRoute: typeof GalleryChecksRoute
  LearnLessonRoute: typeof LearnLessonRoute
  WatchSourceItemRoute: typeof WatchSourceItemRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/curate': {
      id: '/curate'
      path: '/curate'
      fullPath: '/curate'
      preLoaderRoute: typeof CurateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journey': {
      id: '/journey'
      path: '/journey'
      fullPath: '/journey'
      preLoaderRoute: typeof JourneyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spaces': {
      id: '/spaces'
      path: '/spaces'
      fullPath: '/spaces'
      preLoaderRoute: typeof SpacesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery_/checks': {
      id: '/gallery_/checks'
      path: '/gallery/checks'
      fullPath: '/gallery/checks'
      preLoaderRoute: typeof GalleryChecksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn/$lesson': {
      id: '/learn/$lesson'
      path: '/learn/$lesson'
      fullPath: '/learn/$lesson'
      preLoaderRoute: typeof LearnLessonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watch/$source/$item': {
      id: '/watch/$source/$item'
      path: '/watch/$source/$item'
      fullPath: '/watch/$source/$item'
      preLoaderRoute: typeof WatchSourceItemRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  CurateRoute: CurateRoute,
  GalleryRoute: GalleryRoute,
  JourneyRoute: JourneyRoute,
  ReviewRoute: ReviewRoute,
  SettingsRoute: SettingsRoute,
  SignInRoute: SignInRoute,
  SpacesRoute: SpacesRoute,
  StartRoute: StartRoute,
  GalleryChecksRoute: GalleryChecksRoute,
  LearnLessonRoute: LearnLessonRoute,
  WatchSourceItemRoute: WatchSourceItemRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
